// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__eI9RX","loading":"styles_loading__OEnnt","active":"styles_active__pic3p","label":"styles_label__x51+b","circle":"styles_circle__54x4I"};